import { unsafeCSS } from 'lit';
import componentsCss from './components.css?inline';

/**
 * Merged stylesheet exposed as a Lit `CSSResult`.
 *
 * Every Lit component MUST include this in its `static styles` array as the
 * first entry, so the reusable class-based styling (`.tile`, `.modal`,
 * `.overlay`, `.button-*`, `.text-*`) is available inside its shadow root.
 *
 *   import { shared } from '../styles/shared.js';
 *
 *   class MyElement extends LitElement {
 *     static styles = [shared, css`/* component-specific overrides only *\/`];
 *   }
 */
export const shared = unsafeCSS(componentsCss);
